/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Tracking_Audit_LegacyInputs */

const en_orders_tracking_audit_legacy = /** @type {(inputs: Orders_Tracking_Audit_LegacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legacy tracking · actor unavailable`)
};

const es_orders_tracking_audit_legacy = /** @type {(inputs: Orders_Tracking_Audit_LegacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracking heredado · actor no disponible`)
};

/**
* | output |
* | --- |
* | "Legacy tracking · actor unavailable" |
*
* @param {Orders_Tracking_Audit_LegacyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_tracking_audit_legacy = /** @type {((inputs?: Orders_Tracking_Audit_LegacyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Tracking_Audit_LegacyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_tracking_audit_legacy(inputs)
	return es_orders_tracking_audit_legacy(inputs)
});